<template>
  <div class="order-summary">
    <div class="order-container">
      <h2 class="bold-text">{{ isOrderSummaryInformation.isordersummary }}</h2>
      <img :src="summaryDetails.getPoster" style="width:19vw" />
      <div class="plan-title" v-if="orderDetails.transactionPurpose === 'SUBSCRIPTION'">
        <h3 class="bold-text">{{ summaryDetails.planname }}</h3>
        <p class="light-text small-text" v-if="!summaryDetails.rental">
          {{ validity }} {{ isOrderSummaryInformation.isValidity }}
        </p>
        <p class="light-text small-text" v-else-if="summaryDetails.planinterval">
          {{ summaryDetails.planinterval }}
          {{ isOrderSummaryInformation.isHoursValidity }}
        </p>
      </div>
      <div class="plan-title" v-else-if="orderDetails.transactionPurpose === 'PURCHASE'">
        <h3 class="bold-text">{{ orderDetails.content.title }}</h3>
      </div>
      <div class="cost-details">
        <div class="rows cost light-text">
          <p>{{ isOrderSummaryInformation.isPrice }}</p>
          <div class="price" dir="ltr">
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'USD'">$</span>
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'INR'">₹</span>
            <p>{{ costPrice }}</p>
          </div>
        </div>
        <div class="rows light-text">
          <p>{{ isOrderSummaryInformation.isDiscount }}</p>
          <div class="price" dir="ltr">
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'USD'">$</span>
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'INR'">₹</span>
            <p>{{ discountPrice ? discountPrice : 0 }}</p>
          </div>
        </div>
        <div class="rows total-cost bold-text">
          <h4>{{ isOrderSummaryInformation.isTotalPrice }}</h4>
          <div class="price" dir="ltr">
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'USD'">$</span>
            <span :class="[localDisplayLang === 'ara' ? 'currency_rtl' : 'currency']" v-if="summaryDetails.currency === 'INR'">₹</span>
            <p>{{ totalCost }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-container" v-if="isCouponEnabled">
      <h4 class="coupon-query bold-text">
        {{ isOrderSummaryInformation.isCouponCode }}
      </h4>
      <div class="coupon-input flex-row">
        <input type="text" :placeholder="couponCodePlaceholder" id="input" v-model="couponCode" maxlength="30" :disabled="processing" />
        <Loading v-if="loader"></Loading>
        <span 
          :class="[localDisplayLang === 'ara' ? 'coupon-actions-ara' : 'coupon-actions', { 'disabled': processing }]" 
          v-else-if="showRemove" 
          @click="removeCoupon"
        >
          {{ processing ? $t('Processing...') : $t('Remove') }}
        </span>
        <span 
          :class="[localDisplayLang === 'ara' ? 'coupon-actions-ara' : 'coupon-actions', { 'disabled': processing }]" 
          v-else 
          @click="verifyCoupon"
        >
          {{ processing ? $t('Processing...') : isOrderSummaryInformation.isApplyCoupon }}
        </span>
      </div>
      <div class="couponText" v-if="showRemove">
        <p>{{ applyCouponText }}</p>
      </div>
    </div>
    <div class="popup-overlay" v-if="isActiveSuccessfullPayment">
      <div class="popup-content confirmation-success">
        <div class="confirmation-title">
          <h5>{{ $t("Hooray! Purchase Complete!") }}</h5>
          <div class="plan-code-style">
            <h6>{{ summaryDetails.planname || orderDetails.content.title }}</h6>
            <p>{{ $t("Dive into your content now!") }}</p>
            <p class="price-display" v-html="currencyCodeSubscriber(summaryDetails)"></p>
          </div>
          <div class="login-button">
            <button class="button-primary login" type="button" @click="closePopupnRedirectToDetail">
              {{ $t("Start Watching") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import { mapGetters } from "vuex";
import { showSnackBar } from "@/utilities.js";

export default {
  name: 'OrderSummary',
  props: {
    orderDetails: {
      type: Object,
      required: true,
    },
    couponCodeProp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentDate: null,
      validity: null,
      costPrice: "",
      totalCost: "",
      couponCode: null,
      summaryDetails: null,
      loader: false,
      processing: false,
      isActiveSuccessfullPayment: false,
      contentDetailPath: null,
      showRemove: false,
      discountPrice: null,
      couponPrecheckObj: null,
      localDisplayLang: null,
      isCouponEnabled: false,
      applyCouponText: "",
      isOrderSummaryInformation: {},
      couponCodePlaceholder: null,
      isPurchasePending: false,
      debounceTimeout: null,
    };
  },
  computed: {
    ...mapGetters(["appConfig", "subscriptionList"]),
  },
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.summaryDetails = this.orderDetails.detail;
    this.couponCodePlaceholder = this.$t("coupon code");
    this.currentDate = this.getCurrentDate();
    this.getValidity();
    this.setContentDetailPath();
    this.isCouponEnabled = this.appConfig.featureEnabled.hasCouponEnabled;
    this.isOrderSummaryInformation.isordersummary = this.$t("order summary");
    this.isOrderSummaryInformation.isValidity = this.$t("days validity");
    this.isOrderSummaryInformation.isPrice = this.$t("price");
    this.isOrderSummaryInformation.isDiscount = this.$t("Discount");
    this.isOrderSummaryInformation.isTotalPrice = this.$t("total price");
    this.isOrderSummaryInformation.isHoursValidity = this.$t("hours validity");
    this.isOrderSummaryInformation.isCouponCode = this.$t("have a coupon code?");
    this.isOrderSummaryInformation.isApplyCoupon = this.$t("Apply");

    eventBus.$on("validate-coupon", this.handleCouponValidation);
    eventBus.$on("free-purchase-response", this.handleFreePurchaseResponse);
    eventBus.$on("show-success-popup", () => {
      this.isActiveSuccessfullPayment = this.summaryDetails || {};
      this.loader = false;
      this.processing = false;
      this.$forceUpdate();
    });

    let localCouponCode = localStorage.getItem("offerCoupon");
    if (localCouponCode) {
      localCouponCode = JSON.parse(localCouponCode);
    }

    if (this.subscriptionList?.length > 0) {
      eventBus.$emit("close-payment-popup");
      this.$router.push("/");
      return;
    }

    if (localCouponCode && localCouponCode.planId === this.orderDetails.detail.planid) {
      this.couponCode = localCouponCode.coupon;
      this.verifyCoupon();
    } else if (this.couponCodeProp) {
      this.couponCode = this.couponCodeProp;
      this.verifyCoupon();
    }
  },
  beforeDestroy() {
    eventBus.$off("validate-coupon", this.handleCouponValidation);
    eventBus.$off("free-purchase-response", this.handleFreePurchaseResponse);
    eventBus.$off("show-success-popup");
    clearTimeout(this.debounceTimeout);
  },
  methods: {
    setContentDetailPath() {
      if (this.orderDetails.detail?.originalUrl) {
        this.contentDetailPath = this.orderDetails.detail.originalUrl;
      } else if (this.orderDetails.originalUrl) {
        this.contentDetailPath = this.orderDetails.originalUrl;
      } else if (this.orderDetails.content?.originalUrl) {
        this.contentDetailPath = this.orderDetails.content.originalUrl;
      } else {
        const slug =
          this.orderDetails.detail?.slug ||
          this.orderDetails.slug ||
          this.orderDetails.content?.slug ||
          (this.orderDetails.detail?.planname
            ? this.orderDetails.detail.planname
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "--")
            : "default");
        const contentId = (
          this.orderDetails.detail?.objectid ||
          this.orderDetails.content?.objectid ||
          this.orderDetails.objectid
        )?.toLowerCase();

        if (slug && contentId) {
          this.contentDetailPath = `/details/${slug}/${contentId}`;
        } else {
          this.contentDetailPath = `/details/default/${contentId || "unknown"}`;
        }
      }
    },
    debounce(func, wait) {
      return function (...args) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    verifyCoupon() {
      const debouncedVerify = this.debounce(() => {
        if (!this.couponCode) {
          showSnackBar(this.$t("Please Enter Coupon code"));
          return;
        }
        this.loader = true;
        this.processing = true;
        const payload = {
          transactionpurpose: "PURCHASE",
          objectid:
            this.orderDetails.detail.objectid ||
            this.orderDetails.content?.objectid,
          availabilityid: this.orderDetails.detail.availabilityid,
          couponid: this.couponCode.trim(),
          priceclassid: this.orderDetails.detail.priceclassid,
        };
        eventBus.$emit("purchase-coupon-precheck", payload);
      }, 500);
      debouncedVerify.call(this);
    },
    handleCouponValidation(response) {
      this.showRemove = true;
      document.getElementById("input").onkeydown = function (event) {
        event.preventDefault();
      };

      if (response.reason || response.errorcode) {
        this.loader = false;
        this.processing = false;
        showSnackBar(this.$t(response.reason || "Coupon validation failed"));
        this.removeCoupon();
        localStorage.removeItem("offerCoupon");
        return;
      }

      this.applyCouponText = this.getCouponText(
        this.appConfig.messagesList,
        response.nextbilling
      );
      this.couponPrecheckObj = response;

      this.costPrice = (response.amount / 100).toFixed(2);
      this.discountPrice = (response.discount / 100).toFixed(2);
      this.totalCost = (response.finalamount / 100).toFixed(2);

      if (parseFloat(this.totalCost) === 0 && !this.isPurchasePending) {
        this.isPurchasePending = true;
        // Keep loader and processing true until free purchase response
        const payload = {
          objectid:
            this.orderDetails.detail.objectid ||
            this.orderDetails.content?.objectid,
          availabilityid: this.orderDetails.detail.availabilityid,
          couponid: this.couponCode,
          priceclassid: this.couponPrecheckObj.priceclassid,
        };
        eventBus.$emit("create-free-purchase", payload);
      } else if (parseFloat(this.totalCost) > 0) {
        this.loader = false;
        this.processing = false;
        const payload = {
          totalFinalCost: parseInt(this.totalCost * 100),
          couponCode: response.couponid,
          isCoupon: true,
        };
        const analyticsData = {
          nextbilling: response.nextbilling,
          couponCode: payload.couponCode,
          discountPrice: this.discountPrice,
        };
        localStorage.setItem(
          "payment_analytics_data",
          JSON.stringify(analyticsData)
        );
        localStorage.removeItem("offerCoupon");
        this.$emit("totalAfterDiscount", payload);
      }
    },
    handleFreePurchaseResponse(response) {
      this.isPurchasePending = false;
      if (!response.errorcode && response.purchaseid) {
        this.isActiveSuccessfullPayment = this.summaryDetails || {};
      } else {
        this.loader = false;
        this.processing = false;
        showSnackBar(this.$t("Free purchase failed"));
      }
    },
    closePopupnRedirectToDetail() {
      this.isActiveSuccessfullPayment = false;
      this.loader = false;
      this.processing = false;
      this.setContentDetailPath();
      this.$router.push(this.contentDetailPath || "/");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    removeCoupon() {
      document.getElementById("input").onkeydown = function (event) {
        event.returnValue = true;
      };
      this.showRemove = false;
      this.applyCouponText = "";
      this.couponCode = null;
      this.costPrice = parseInt(this.summaryDetails.amount) / 100;
      this.discountPrice = 0;
      this.totalCost = parseInt(this.summaryDetails.amount) / 100;
      this.loader = false;
      this.processing = false;
      const payload = {
        totalFinalCost: this.totalCost * 100,
        couponCode: null,
        isCoupon: false,
      };
      this.$emit("totalAfterDiscount", payload);
    },
    getCurrentDate() {
      const d = new Date();
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    getValidity() {
      this.validity =
        this.summaryDetails.planinterval === "MONTH"
          ? "30"
          : this.summaryDetails.planinterval === "YEAR"
            ? "365"
            : this.summaryDetails.planinterval === "HALFYEAR"
              ? "183"
              : this.summaryDetails.planinterval === "WEEK"
                ? "7"
                : typeof this.summaryDetails.planinterval === "number"
                  ? this.summaryDetails.planinterval.toString()
                  : "90";
      this.costPrice = parseInt(this.summaryDetails.amount) / 100;
      this.totalCost = parseInt(this.summaryDetails.amount) / 100;
    },
    getCouponText(messageList, date) {
      return this.localDisplayLang === "ara"
        ? `${messageList.ar.couponApplyMessage} (${this.displayDateFormat(date)})`
        : `${messageList.en.couponApplyMessage} (${this.displayDateFormat(date)})`;
    },
    currencyCodeSubscriber(details) {
      const currencySymbol =
        details.currency === "USD"
          ? "$"
          : details.currency === "INR"
            ? "₹"
            : "";
      return `<span class="price-accent">${currencySymbol}${this.totalCost}</span>`;
    },
  },
  components: {
    Loading: () =>
      import(
        /* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"
      ),
  },
  mixins: [Utility],
};
</script>

<style lang="scss">
@import "@/sass/_variables.scss";
@import "./OrderSummary.scss";

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  animation: fadeIn 0.3s ease-out;
}

.popup-content {
  background: linear-gradient(135deg, #1c2526 0%, #2a3435 100%);
  border-radius: 16px;
  width: 90%;
  max-width: 450px;
  padding: 24px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
  animation: scaleIn 0.3s ease-out;
}

.confirmation-success {
  text-align: center;
}

.confirmation-title {
  h5 {
    margin: 0 0 16px;
    font-size: 1.5rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.5px;
  }
}

.plan-code-style {
  margin: 16px 0;

  h6 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #28a745;
    margin-bottom: 8px;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    color: #cccccc;
    margin: 4px 0;
  }

  .price-display {
    font-size: 1.1rem;
    font-weight: 500;

    .price-accent {
      color: #28a745;
    }
  }
}

.login-button {
  margin-top: 24px;

  .button-primary {
    background-color: #fff;
    color: #000;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: 500;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.2s, transform 0.2s;

    &:hover {
      background-color: #fff;
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

.coupon-actions.disabled, .coupon-actions-ara.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>